/**
 * Today at local midnight.
 *
 * Normalising away the time matters: these forms use formik's
 * `enableReinitialize`, which re-seeds whenever the initial values stop being
 * deeply equal. A raw `new Date()` changes on every render and would reset the
 * form under the user; a date pinned to midnight is stable for the whole day.
 */
export const today = () => {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
};
